






import { Component, Vue } from "vue-property-decorator";
import HRM from "./components/Heartrate.vue";

@Component({
  components: {
    HRM
  }
})
export default class App extends Vue {}
